import { DataCardBody_Root } from 'emerald-ui/dist/DataCard';
import { LabeledValue_Root } from 'emerald-ui/dist/LabeledValue';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const TrackingPage_Root = styled.div`
    ${theme.breakpoints.only('xs')} {
        ${DataCardBody_Root} {
            ${LabeledValue_Root} {
                font-size: 1rem; /* 16px */
            }
        }
    }
`;
